import z from "zod";

export const postCalculationMemberSchema = z.object({
	userId: z.string().min(1),
});

export type PostCalculationMemberSchema = z.infer<typeof postCalculationMemberSchema>;
